import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Store, CheckCircle2, Pencil, CalendarDays } from "lucide-react";

export default function StoreGoalCard({ loja, vendas, meta, progresso, atingida, fmt, onEditMeta, onOpenDaily }) {
  const [editing, setEditing] = useState(false);

  const salvar = (value) => {
    setEditing(false);
    const num = parseFloat(value);
    if (value !== "" && !Number.isNaN(num) && num !== meta) {
      onEditMeta(loja, value);
    }
  };

  return (
    <div
      className="relative flex flex-col p-6 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-200 cursor-pointer group"
      onClick={() => onOpenDaily(loja)}
      data-testid={`store-goal-card-${loja}`}
    >
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-xl transition-colors ${atingida ? "bg-emerald-50 text-emerald-600" : "bg-slate-50 text-slate-600 group-hover:bg-blue-50 group-hover:text-blue-600"}`}>
            <Store className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-lg font-semibold tracking-tight text-slate-800 leading-tight">{loja}</h3>
            <span className="text-xs font-medium uppercase tracking-wider text-slate-400 flex items-center gap-1">
              <CalendarDays className="w-3 h-3" /> Ver vendas do mês
            </span>
          </div>
        </div>
        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${atingida ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-blue-50 text-blue-700 border-blue-200"}`}>
          {atingida && <CheckCircle2 className="w-3 h-3" />}
          {progresso}%
        </span>
      </div>

      <div className="mb-4 space-y-1">
        <p className="text-xs font-medium uppercase tracking-wider text-slate-400">Vendas no mês</p>
        <p className="text-3xl font-black tracking-tighter text-slate-900">{fmt(vendas)}</p>

        <div
          className="flex items-center gap-2 text-sm text-slate-500 pt-1"
          onClick={(e) => e.stopPropagation()}
        >
          {editing ? (
            <Input
              autoFocus
              type="number"
              step="0.01"
              defaultValue={meta || ""}
              placeholder="Valor da meta"
              onBlur={(e) => salvar(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") salvar(e.target.value); }}
              className="h-7 w-32 px-2 py-1 text-sm rounded-md focus:ring-2 focus:ring-blue-100 focus:border-blue-500"
              data-testid={`goal-edit-input-${loja}`}
            />
          ) : (
            <button
              type="button"
              onClick={() => setEditing(true)}
              className="inline-flex items-center gap-1.5 hover:text-blue-600 transition-colors"
              data-testid={`goal-edit-btn-${loja}`}
            >
              Meta: <span className="font-semibold text-slate-700">{fmt(meta)}</span>
              <Pencil className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
            </button>
          )}
        </div>
      </div>

      <div className="mt-auto">
        <div className="h-2.5 w-full bg-slate-100 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ease-out ${atingida ? "bg-emerald-500" : "bg-blue-500"}`}
            style={{ width: `${progresso}%` }}
          />
        </div>
      </div>
    </div>
  );
}
